import { t } from "@lingui/macro";
import * as React from "react";
import { Path, Circle } from "react-native-svg";

import { Icon, IconProps } from "../../../primitive";

export const WalkingIcon = (props: IconProps) => (
  <Icon
    fill="none"
    viewBox="0 0 16 16"
    color="#001A19"
    testID="walking-icon"
    title={t`Walking`}
    {...props}
  >
    <Path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="m4 15 2-3 1-6M7 6 4.5 7.5 3.5 9"
    />
    <Path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="M9.5 15 9 12.5 6.5 9M7 6l1.6 1.714L11 9"
    />
    <Circle cx={8} cy={3} r={2} fill="currentColor" />
  </Icon>
);
